import { SubJobCodeListRequest } from "@gtpl/shared-models/planning";
import { ApiProperty } from "@nestjs/swagger";
import { SubJobRevisionCodesRequest } from "./sub-job-revision-code-list-req";
import { subJobItemDto } from "./subjob-item-dto";

export class SubJobRequest {
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    itemDetails:subJobItemDto[]
    @ApiProperty()
    traceCodesData?: SubJobRevisionCodesRequest[];
    @ApiProperty()
    createdUser?: string;
}

